module.exports = __webpack_public_path__ + "static/img/2_04.710b71b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_04.jpg
// module id = UpQ+
// module chunks = 1